export default {
  name: 'funding',
  namespaced: true,
  state: {
    investFundingsRawDatas: [],
    investFundings: [],
    announcements: [],
    aiInvestmentResult: null // AI 투자 결과 저장
  },
  mutations: {
    setInvestFundingsRawDatas(state, investFundingsRawDatas) {
      state.investFundingsRawDatas = investFundingsRawDatas
    },
    setInvestFundings(state, investFundings) {
      state.investFundings = investFundings
    },
    setAnnouncements(state, announcements) {
      state.announcements = announcements
    },
    setAiInvestmentResult(state, result) {
      state.aiInvestmentResult = result
    },
    clearAiInvestmentResult(state) {
      state.aiInvestmentResult = null
    }
  },
  actions: {
    async getFundingAnnouncements({ commit }, fundingDataIdxes) {
      const results = await global.$fundaApi.getFundingAnnouncements(fundingDataIdxes)
      commit('setAnnouncements', results)
      return results
    }
  },
}
